import React, { useEffect, useState, useCallback, lazy, Suspense } from "react";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Toaster from "../component/Toaster";
import api from "../constants/API";
import { CategoryDiscount } from "../constants/constants";
import ExamsSection from "./ExamsSection";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Helmet } from "react-helmet";
import YouTubeEmbed from "./YouTubeEmbed";
import ReactDOM from "react-dom";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";

import {
  Btn,
  CardBox,
  SaveBox,
  FeatureBox,
  FeatureText,
  svgCode,
  CustomMenuItem,
  CustomSelect2,
  DetailsBox,
  Title,
  // VideoResponsive,
} from "./styles";
import BreadCrumb from "../component/BreadCrumb";
import { AppContext } from "../App";
import { PricingCardSkeleton, ContentSkeleton } from "./PricingCardSkeletion";
const Login = lazy(() => import("../authentication/Auth/LoginComponent"));

function ExamCategoryPage() {
  const location = useLocation();
  const { pathname, search } = location;
  const params = new URLSearchParams(search);
  const initialPage = params.get("page") ? parseInt(params.get("page")) - 1 : 0;
  const [page, setPage] = useState(initialPage);
  const [canonicalUrl, setCanonicalUrl] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [bundlePrice, setBundlePrice] = useState(0);
  const [persistentMessage, setPersistentMessage] = useState("");
  const { setCardItemNumber, toggle } = React.useContext(AppContext) || {};
  const [dataReady, setDataReady] = useState(false);
  const pathspilt = pathname.split("/");
  // let ExamVendorName = decodeURIComponent(pathspilt[1].replace(/-/g, "%20"));
  let ExamVendorName = decodeURIComponent(pathspilt[1].toLowerCase());
  const [demoExam, setDemoExam] = useState({});
  const [metaData, setMetaData] = useState({});
  const [loading, setLoading] = useState(false);
  const [cardData, setCardData] = useState([]);
  const [exams, setExams] = useState([]);
  const [examLength, setExamLength] = useState(0);
  const [regModal, setRegModal] = useState(false);
  const [duration3, setDuration3] = useState("1");
  const [loginModal, setLoginModal] = useState(false);
  const [processedPageContent, setProcessedPageContent] = useState("");
  const [processedPageContent2, setProcessedPageContent2] = useState("");
  const [contentLoaded, setContentLoaded] = useState(false);
  const navigate = useNavigate();
  const [alert, setAlert] = useState({
    open: false,
    type: "info",
    text: "",
  });

  const getData = useCallback(async () => {
    setLoading(true);
    setDataReady(false);
    setMetaData({});
    setDemoExam({});
    try {
      await getExamsPaginated();
      setDataReady(true);
    } catch (err) {
      navigate("/error");
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [ExamVendorName, page]);
  // After the handlePageChange function and before the return statement
  const shouldNoIndexPage = () => {
    // No-index pages beyond page 10
    return page + 1 > 10;
  };
  useEffect(() => {
    const params = new URLSearchParams(search);
    const pageParam = params.get("page");
    const newPage = pageParam ? parseInt(pageParam) - 1 : 0;
    if (newPage !== page) {
      setPage(newPage);
    }

    // Set the canonical URL
    const baseUrl = `${window.location.origin}/${ExamVendorName.replace(
      / /g,
      "-"
    ).toLowerCase()}`;
    setCanonicalUrl(newPage === 0 ? baseUrl : `${baseUrl}?page=${newPage + 1}`);
  }, [search, demoExam.ExamVendorName]);

  useEffect(() => {
    getData();
  }, [page, getData, ExamVendorName]);

  const handleInput3 = (e) => {
    setDuration3(e.target.value);
  };

  const getExamsPaginated = useCallback(async () => {
    try {
      if (ExamVendorName.includes("c++")) {
        ExamVendorName = ExamVendorName.replace("c++", "cpp");
      }
      const { data } = await api.get(
        // `api/Exam/GetCategoryBasedExam_updated_pagination?ExamVendorName=${ExamVendorName}&SiteId=1&page=${page}&limit=10`
        `api/Exam/GetCategoryBasedExam?ExamVendorName=${ExamVendorName}&SiteId=1&page=${page}&limit=10`
      );
      const bundleItem = data?.Exam.PriceCards.find(
        (item) => item.ExamPrice >= 300
      );
      setCardData([bundleItem]);
      setBundlePrice(bundleItem?.ExamPrice || 0);
      setExams(data.Exam.Items);
      setExamLength(data.Exam.TotalExams);
      setMetaData(data.CategoryTitleMeta.Items[0]);
      setDemoExam(data.CategoryTitleMeta.Items[0]);
      localStorage.setItem("currentExamId", data.Exam.Items[0]?.ExamId);
      setTotalPages(Math.ceil(data.Exam?.TotalExams / 10));
    } catch (err) {
      navigate("/error");
      console.log(err);
    }
  }, [ExamVendorName, page]);

  const extractTitle = useCallback((content) => {
    if (content) {
      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(content, "text/html");
      const h1 = htmlDoc.querySelector("h1");
      if (h1) {
        const title = h1.textContent;
        h1.remove();
        return { title, content: htmlDoc.body.innerHTML };
      }
    }
    return { title: null, content };
  }, []);

  const [extractedTitle, setExtractedTitle] = useState(null);

  const regToggle = () => {
    if (loginModal) {
      setLoginModal(false);
    }
    setRegModal((prev) => !prev);
  };

  const alertToggle = () => {
    setAlert({
      open: false,
      text: "",
      type: "info",
    });
  };

  const calculatePrice = (duration, basePrice) => {
    let price;
    switch (duration) {
      case "1":
        price = basePrice;
        break;
      case "2":
        price = basePrice * 1.5;
        break;
      case "3":
        price = basePrice * 2;
        break;
      default:
        return basePrice;
    }
    return price;
  };

  const handleAddToCart = async (vendorName, bundelType, dur, type) => {
    try {
      setLoading(true);
      const { data } = await api.get(
        // `api/Exam/GetCategoryBasedExam_updated?ExamVendorName=${ExamVendorName}&SiteId=1`
        `api/Exam/GetCategoryBasedExam_addtoCart?ExamVendorName=${ExamVendorName}&SiteId=1`
      );
      const allExams = data.Exam.Items;
      const availableExams = allExams.filter((exam) => !exam.IsPreOrder);

      if (availableExams.length === 0) {
        setAlert({
          open: true,
          text: "All exams in this bundle are currently pre-order only and cannot be added to the cart.",
          type: "info",
        });
        return;
      }

      const shoppingItems = localStorage.getItem("shoppingItems");
      let prvItem = shoppingItems ? JSON.parse(shoppingItems) : [];

      const bundleshoppingItems = localStorage.getItem("bundleshoppingItems");
      let prvbundledItem = bundleshoppingItems
        ? JSON.parse(bundleshoppingItems)
        : [];

      if (prvItem.some((item) => item.examCode === metaData?.ExamVendorName)) {
        setAlert({
          open: true,
          text: "Exam Bundle Already exists in your Cart",
          type: "warning",
        });
        return;
      }

      const itemsToAdd = availableExams.map((exam) => ({
        pack: bundelType,
        duration: dur,
        examCode: exam?.ExamCode,
        exameId: exam?.ExamId,
        type: type,
        vendor: vendorName,
      }));

      const newItemsToAdd = itemsToAdd.filter((newItem) => {
        return !prvbundledItem.some(
          (existingItem) => existingItem.examCode === newItem.examCode
        );
      });
      const updatedItemsCart = [...prvbundledItem, ...newItemsToAdd];

      updatedItemsCart.forEach((item, i) => {
        item.id = i + 1;
      });

      localStorage.setItem(
        "bundleshoppingItems",
        JSON.stringify(updatedItemsCart)
      );

      prvItem.push({
        pack: bundelType,
        duration: dur,
        examCode: vendorName,
        // examCode: ExamVendorName,
        type: type,
      });

      prvItem.forEach((item, i) => {
        item.id = i + 1;
      });

      localStorage.setItem("shoppingItems", JSON.stringify(prvItem));
      setCardItemNumber(prvItem.length);
      toggle();

      if (availableExams.length < allExams.length) {
        const excludedCount = allExams.length - availableExams.length;
        setPersistentMessage(
          `${excludedCount} exam${
            excludedCount > 1 ? "s were" : " was"
          } excluded as ${
            excludedCount > 1 ? "they are" : "it is"
          } pre-order only. Added ${availableExams.length} out of ${
            allExams.length
          } exams to the cart.`
        );
      }
    } catch (err) {
      console.log(err);
      setAlert({
        open: true,
        text: "An error occurred while adding items to the cart.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!loading && dataReady) {
      const replaceYouTubeLinks = (content) => {
        const youtubeRegex =
          /https?:\/\/(?:www\.)?(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]+)/g;
        return content.replace(youtubeRegex, (match, videoId) => {
          const isShort = match.includes("/shorts/");
          return `<div class="youtube-embed" data-video-id="${videoId}" data-is-short="${isShort}"></div>`;
        });
      };

      if (metaData?.PageContent) {
        const { title, content } = extractTitle(metaData.PageContent);
        setExtractedTitle(title);
        const updatedContent = replaceYouTubeLinks(content);
        setProcessedPageContent(updatedContent);
      }

      if (metaData?.PageContentChild) {
        const updatedContent2 = replaceYouTubeLinks(metaData.PageContentChild);
        setProcessedPageContent2(updatedContent2);
      }

      const replaceEmbeds = () => {
        const embeds = document.getElementsByClassName("youtube-embed");
        Array.from(embeds).forEach((embed) => {
          const videoId = embed.getAttribute("data-video-id");
          const isShort = embed.getAttribute("data-is-short") === "true";
          ReactDOM.render(
            <YouTubeEmbed videoId={videoId || ""} isShort={isShort} />,
            embed
          );
        });
      };

      setTimeout(replaceEmbeds, 100);
      setContentLoaded(true);
    }
  }, [loading, dataReady, metaData, extractTitle]);

  const clearPersistentMessage = () => {
    setPersistentMessage("");
  };

  const handlePageChange = (event, value) => {
    setPage(value - 1);
    if (value === 1) {
      navigate(`/${ExamVendorName.replace(/ /g, "-")}`);
    } else {
      navigate(`/${ExamVendorName.replace(/ /g, "-")}?page=${value}`);
    }
  };

  return (
    <>
      <Helmet>
        <title>
          {metaData.Title
            ? metaData.Title.replace(
                /\{%category-name%\}/g,
                demoExam?.ExamVendorName || ""
              ) + (page > 0 ? ` - Page ${page + 1}` : "")
            : `${
                demoExam.ExamVendorName
              } Certification Exams Real Practice Tests PDF Download${
                page > 0 ? ` - Page ${page + 1}` : ""
              }`}
        </title>
        {/* Add noindex for deep pagination pages */}
        {shouldNoIndexPage() && (
          <meta name="robots" content="noindex, follow" />
        )}
        <meta
          name="description"
          content={
            metaData.MetaDescription
              ? metaData.MetaDescription.replace(
                  /\{%category-name%\}/g,
                  demoExam?.ExamVendorName || ""
                ) + (page > 0 ? ` - Page ${page + 1}` : "")
              : `Guaranteed success in ${
                  demoExam.ExamVendorName || "Exam"
                } with DirectCertify: Get the latest ${
                  demoExam.ExamVendorName || "Exam"
                } Certification Practice Tests & PDF download dumps${
                  page > 0 ? ` - Page ${page + 1}` : ""
                }. Elevate your skills and pass with confidence!`
          }
        />

        {/* Canonical URL */}
        <link rel="canonical" href={canonicalUrl} />

        {/* rel="prev" */}
        {page > 0 && (
          <link
            rel="prev"
            href={
              page - 1 === 0
                ? `/${ExamVendorName.replace(/ /g, "-").toLowerCase()}`
                : `/${ExamVendorName.replace(
                    / /g,
                    "-"
                  ).toLowerCase()}?page=${page}`
            }
          />
        )}

        {/* rel="next" */}
        {page + 1 < totalPages && (
          <link
            rel="next"
            href={`/${ExamVendorName.replace(/ /g, "-").toLowerCase()}?page=${
              page + 2
            }`}
          />
        )}
      </Helmet>

      <Box sx={{ my: 10 }}>
        <Toaster props={alert} onClose={alertToggle} />

        <Suspense fallback={<div>Loading...</div>}>
          {loginModal && (
            <Login
              open={loginModal}
              onClose={() => setLoginModal(false)}
              onReg={regToggle}
            />
          )}
        </Suspense>
        {persistentMessage && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              backgroundColor: "#FFD500",
              padding: 2,
              zIndex: 9999,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="body1">{persistentMessage}</Typography>
            <IconButton onClick={clearPersistentMessage} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        )}
        <Container sx={{ marginTop: { xs: "125px", md: "110px" } }}>
          <Box
            display={"flex"}
            sx={{
              mx: 2,
              justifyContent: {
                sm: "space-evenly",
                xs: "space-evenly",
                md: "flex-start",
              },
            }}
          >
            <BreadCrumb text="Home" to="/" isLast={false} />
            <BreadCrumb
              text={metaData?.ExamVendorName || ""}
              to=""
              isLast={true}
            />
          </Box>
          <Container sx={{ marginBottom: "10px", marginTop: "10px" }}>
            {loading || !dataReady ? (
              <PricingCardSkeleton />
            ) : (
              <CardBox
                sx={{
                  background: "#27B1BB",
                  backgroundImage: `url("data:image/svg+xml,${encodeURIComponent(
                    svgCode
                  )}")`,
                }}
              >
                <Stack
                  sx={{
                    display: "flex",
                    flexDirection: { md: "row" },
                    justifyContent: {
                      md: "space-between",
                      sm: "center",
                      xs: "center",
                    },
                    alignItems: { sm: "center", xs: "center" },
                    marginBottom: { sm: "20px", xs: "20px" },
                    marginTop: "-10px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { sm: "22px", xs: "22px", md: "28px" },
                      fontFamily: "Poppins",
                      fontWeight: 700,
                      color: "#ffff",
                    }}
                  >
                    {metaData?.ExamVendorName} Exams Bundle
                  </Typography>
                  <SaveBox sx={{ marginTop: { sm: "10px", xs: "10px" } }}>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontFamily: "Poppins",
                        fontWeight: 700,
                        color: "#27B1BB",
                      }}
                    >
                      {`Save ${CategoryDiscount}%`}
                    </Typography>
                  </SaveBox>
                </Stack>
                <Stack
                  sx={{
                    display: "flex",
                    flexDirection: { md: "row" },
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <DetailsBox sx={{ background: "#FFFFFF" }}>
                    <FeatureBox sx={{ border: "1px solid #27B1BB" }}>
                      <FeatureText>
                        <span style={{ fontWeight: "600" }}>Total Exams:</span>{" "}
                        <span style={{ fontWeight: "normal" }}>
                          {examLength}
                        </span>
                      </FeatureText>
                    </FeatureBox>
                    <FeatureBox sx={{ border: "1px solid #27B1BB" }}>
                      <FeatureText>
                        <span style={{ fontWeight: "600" }}>Format:</span>{" "}
                        <span style={{ fontWeight: "normal" }}>
                          PDF & Practice Test
                        </span>
                      </FeatureText>
                    </FeatureBox>
                    <FeatureBox sx={{ border: "1px solid #27B1BB" }}>
                      <FeatureText>
                        <span style={{ fontWeight: "600" }}>
                          90 Days Free Updates
                        </span>
                      </FeatureText>
                    </FeatureBox>
                    <FeatureBox sx={{ border: "1px solid #27B1BB" }}>
                      <FeatureText>
                        <span style={{ fontWeight: "600" }}>
                          30 Days Money Back Guarantee
                        </span>
                      </FeatureText>
                    </FeatureBox>
                  </DetailsBox>
                  <Stack direction="column">
                    <Box sx={{ px: 1, marginBottom: "20px" }}>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontFamily: "Poppins",
                          fontWeight: 800,
                          textAlign: "center",
                          color: "#ffffff",
                        }}
                      >
                        Product Updates
                      </Typography>
                      <FormControl fullWidth size="small">
                        <CustomSelect2
                          value={duration3}
                          onChange={handleInput3}
                        >
                          <CustomMenuItem value="1">3 Months</CustomMenuItem>
                          <CustomMenuItem value="2">6 Months</CustomMenuItem>
                          <CustomMenuItem value="3">9 Months</CustomMenuItem>
                        </CustomSelect2>
                      </FormControl>
                    </Box>
                    <Box
                      sx={{ paddingLeft: "20px", marginBottom: "20px", px: 1 }}
                    >
                      <Btn
                        variant="contained"
                        sx={{
                          background: "#FFD500 !important",
                          filter: "drop-shadow(0px 4px 0px #CFAD00)",
                        }}
                        onClick={() =>
                          handleAddToCart(
                            demoExam?.ExamVendorName,
                            cardData[0],
                            duration3,
                            "Exam BUNDLE"
                          )
                        }
                      >
                        Add To Cart
                      </Btn>
                    </Box>
                  </Stack>
                  <Typography
                    sx={{
                      fontSize: "80px",
                      fontFamily: "Poppins",
                      fontWeight: 800,
                      textAlign: "center",
                      color: "#ffffff",
                    }}
                  >
                    {`$${calculatePrice(duration3, bundlePrice)}`}
                  </Typography>
                </Stack>
              </CardBox>
            )}
          </Container>

          {loading || !dataReady ? (
            <ContentSkeleton />
          ) : (
            <>
              <Title variant="h1">
                {extractedTitle?.replace(
                  /\{%category-name%\}/g,
                  demoExam?.ExamVendorName || ""
                ) || `${demoExam?.ExamVendorName} Exams`}
              </Title>
              <Box
                sx={{
                  margin: "0 auto 10px auto",
                }}
              >
                <Typography
                  sx={{
                    color: "#505050",
                    fontFamily: "Poppins",
                    textAlign: "center",
                    fontWeight: "400",
                    fontSize: { xs: "12px", md: "14px" },
                  }}
                  dangerouslySetInnerHTML={{
                    __html: processedPageContent
                      ? processedPageContent
                          .replace(/\{%exam-code%\}/g, demoExam?.ExamCode || "")
                          .replace(/\{%exam-name%\}/g, demoExam?.ExamName || "")
                          .replace(
                            /\{%category-name%\}/g,
                            demoExam?.ExamVendorName || ""
                          )
                      : "",
                  }}
                />
              </Box>
            </>
          )}
          <ExamsSection loading={loading} exams={exams} />
          <Pagination
            count={totalPages}
            page={page + 1}
            onChange={handlePageChange}
            sx={{
              mt: 4,
              display: "flex",
              justifyContent: "center",
              "& .Mui-selected": {
                backgroundColor: "#27b1bb",
                color: "#fff",
              },
            }}
            renderItem={(item) => {
              if (item.disabled) {
                return <PaginationItem component="div" {...item} />;
              }
              return (
                <PaginationItem
                  component={item.page === page + 1 ? "div" : Link}
                  to={
                    item.page === 1
                      ? `/${ExamVendorName.replace(/ /g, "-").toLowerCase()}`
                      : `/${ExamVendorName.replace(
                          / /g,
                          "-"
                        ).toLowerCase()}?page=${item.page}`
                  }
                  {...item}
                  onClick={item.page === page + 1 ? undefined : item.onClick}
                  sx={
                    item.page === page + 1
                      ? {
                          backgroundColor: "#27b1bb",
                          color: "#fff",
                          "&:hover": {
                            backgroundColor: "#27b1bb",
                            cursor: "default",
                          },
                          pointerEvents: "none",
                        }
                      : {}
                  }
                />
              );
            }}
          />
          {loading || !dataReady ? (
            <ContentSkeleton />
          ) : (
            <>
              {processedPageContent2 && (
                <Typography
                  sx={{
                    color: "#505050",
                    fontFamily: "Poppins",
                    textAlign: "center",
                    fontWeight: "400",
                    fontSize: { xs: "12px", md: "14px" },
                    marginTop: "2rem",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: processedPageContent2
                      ? processedPageContent2
                          .replace(/\{%exam-code%\}/g, demoExam?.ExamCode || "")
                          .replace(/\{%exam-name%\}/g, demoExam?.ExamName || "")
                          .replace(
                            /\{%category-name%\}/g,
                            demoExam?.ExamVendorName || ""
                          )
                      : "",
                  }}
                />
              )}
            </>
          )}

          <Toaster props={alert} onClose={alertToggle} />
        </Container>
      </Box>
    </>
  );
}

export default ExamCategoryPage;
